import { render, staticRenderFns } from "./dialog-error.vue?vue&type=template&id=c8189ae0&"
import script from "./dialog-error.vue?vue&type=script&lang=js&"
export * from "./dialog-error.vue?vue&type=script&lang=js&"
import style0 from "./dialog-error.vue?vue&type=style&index=0&id=c8189ae0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports